"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rocca-priora": {
    "dcb6e811": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-san-rocco": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "889cc4e0": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "buero": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50a3591e": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "l-ara-dandini": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81a6ab16": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-della-neve": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01716108": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "piani-di-caiano": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50d819a4": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "skipSearch": false
    }],
    "san-sebastiano": [{
      "hkey": "4b2a989d",
      "slug": "rocca-priora",
      "name": "Rocca Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;